import { mapActions, mapGetters } from 'vuex';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import { range } from 'lodash';
import marketListItemV2 from '@/components/market/v2/market-list-item-v2/market-list-item-v2.vue';
import { MarketLoader as marketLoader } from '@/components/content-loader';

export default {
  components: {
    marketListItem: marketListItemV2,
    marketLoader,
    swiper,
    swiperSlide,
  },
  props: {
    num: { type: Number, default: 3 },
  },
  data() {
    return {
      isComponentReady: false,
      activeIndex: 0,
      swiperOptions: {
        slidesPerView: 1,
        loop: true,
        direction: 'horizontal',
        spaceBetween: 0,
        onTransitionStart: (swp) => {
          this.activeIndex = swp.activeIndex;
        },
      },
    };
  },
  computed: {
    ...mapGetters('app', ['isLayoutMobile', 'isLayoutDesktop']),
    ...mapGetters('widgets', ['getWidget']),
    widget() {
      return this.getWidget('new-arrivals');
    },
    items() {
      return (this.widget.data || []).slice(0, this.num);
    },
    dummyComponents() {
      if (this.isLayoutMobile) return range(0, 1);
      return range(0, this.num);
    },
    prevArrowModifiers() {
      return {
        'most-predicted-list__header-arrow': true,
        'most-predicted-list__header-arrow--left': true,
      };
    },
    nextArrowModifiers() {
      return {
        'most-predicted-list__header-arrow': true,
        'most-predicted-list__header-arrow--right': true,
      };
    },
  },
  methods: {
    ...mapActions('widgets', ['fetchNewArrivals']),
    prevSlide() {
      this.$refs.swiper.swiper.slidePrev();
    },
    nextSlide() {
      this.$refs.swiper.swiper.slideNext();
    },
  },
  mounted() {
    this.fetchNewArrivals({ limit: this.num })
      .then(() => { this.isComponentReady = true; });
  },
};



// WEBPACK FOOTER //
// ./src/components/home/home-old/most-predicted-list/most-predicted-list.js